import React, { useEffect, useState } from 'react'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import UserNotice from './UserNotice'
import OnlineSubmissionForm from './OnlineSubmissionForm'
import AlternateSubmission from './AlternateSubmission'
import Footer from '../footer/Footer'
import useScrollToTop from '../../hooks/useScrollToTop'
import { useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setField } from '../../state/slice/form'
import { fetchMemberByClaimKey } from '../../state/reducers/fetchMemberByClaimKey'
import REQUEST_STATUS from '../../state/common/REQUEST_STATUS'
import Loader from '../common/Loader'
import Message from '../common/Message'
import ErrorAlert from '../common/ErrorAlert'

export default function Home () {
  const [params] = useSearchParams()
  const dispatch = useDispatch()
  const {
    error,
    context: {
      sessionKilled,
      appDataRequestStatus,
      claimKey: { value: claimKey },
      prePopId: { value: prePopId }
    }
  } = useSelector(state => state.form)
  const firstName = useSelector(state => state.form.segments.employee.fields.firstName.value)

  const [hideError, setHideError] = useState()

  useEffect(() => {
    const groupnumber = params.get('groupnumber')
    if (groupnumber && groupnumber.length === 4) {
      dispatch(setField('segments.employer.fields.groupNumber.value', groupnumber, true))
    }
    const groupname = params.get('groupname')
    if (groupname) {
      dispatch(setField('segments.employer.fields.name.value', groupname, true))
    }
    const subgroup = params.get('subgroup')
    if (subgroup && subgroup.length === 4 && subgroup.startsWith('0')) {
      dispatch(setField('segments.employer.fields.subgroup.value', subgroup, true))
    }
  }, [params, dispatch])

  useEffect(() => {
    if (claimKey) {
      dispatch(fetchMemberByClaimKey(claimKey))
    }
  }, [dispatch, claimKey])

  const closeError = () => {
    setHideError(true)
    dispatch(setField('context.claimKey.value', null))
    dispatch(setField('error', null))
  }

  const componentContent = () => {
    if (appDataRequestStatus === REQUEST_STATUS.FAILED && error && !hideError) {
      return <ErrorAlert
        id='eoi-data-fetch-error'
        content={error}
        onClose={closeError}
      />
    }
    return appDataRequestStatus === REQUEST_STATUS.IN_PROGRESS ?
      <Loader /> : <Grid divided='vertically' className='container-md'>
        <GridRow>
          {sessionKilled && <GridColumn width={16} className='u-mY2'>
            <Message
              content='To protect your personal information, your session timed out after 30 minutes of inactivity.'
              type='alert'
            />
          </GridColumn>}
          <GridColumn width={16}>
            <UserNotice prePopulated={[prePopId, claimKey].some(Boolean)} firstName={firstName} />
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn width={16}>
            <h3>Online Submission</h3>
          </GridColumn>
          <GridColumn width={16}>
            <OnlineSubmissionForm />
          </GridColumn>
        </GridRow>
        <GridRow>
          <AlternateSubmission employeeOnly={[prePopId, claimKey].some(Boolean)} />
        </GridRow>
        <Footer />
      </Grid>
  }

  return useScrollToTop(componentContent())
}